import { AutomatedBreakType } from '@sdk/settings/types';
import gettext from '@sdk/lang/gettext';

const getBreakName = (automatedBreakType: AutomatedBreakType | null) => {
  if (!automatedBreakType) {
    return gettext('break');
  }

  return automatedBreakType === AutomatedBreakType.meal
    ? gettext('meal break')
    : gettext('rest break');
};

export default getBreakName;
